// jQuery
(function ($) {
  $(function () {

    $.widget('custom.catcomplete', $.ui.autocomplete, {
      _create: function () {
        this._super();
        this.widget().menu('option', 'items', '> :not(.ui-autocomplete-category)');
      },
      _renderMenu: function (ul, items) {
        let that = this;
        let currentCategory = '';
        $.each(items, function (index, item) {
          let li;
          if (item.category !== currentCategory) {
            ul.append('<li class=\'ui-autocomplete-category\'>' + item.category + '</li>');
            currentCategory = item.category;
          }
          li = that._renderItemData(ul, item);
          if (item.category) {
            li.attr('aria-label', item.category + ' : ' + item.label);
          }
        });
      },
    });

    let $body = $('body');
    let i = 0;
    let $nav = $('#nav');
    let $socials = $('#scrolled-socials');
    let $slider_adaptive = [];
    let $window = $(window);
    let scroll_area = $body.height() - $window.height() - $('footer').height();
    let $slider_adaptive_items = [];
    let $slider_adaptive_l_items = [];

    $('.chosen').chosen({no_results_text: 'Не найдено:'});

    if ($('#wrapper.new_year').length) {
      $('#search').append('<div id=\'search-snow\' class=\'snow\'></div>');
    }

    if ($.fn.mmenu) {
      // Инициализация
      let api = $nav.mmenu({
        'extensions': [
          'pagedim-black',
        ],
        'counters': true,
        'navbars': [

          {
            'position': 'top',
            'content': [
              'searchfield',
            ],
          },
          /*
                    {
                      'position': 'bottom',
                      'content': [
                        '<a class="fa fa-envelope" href="#/">&nbsp;</a>',
                        '<a class="fa fa-twitter" href="#/">&nbsp;</a>',
                        '<a class="fa fa-facebook" href="#/">&nbsp;</a>',
                      ],
                    },
          */
          true,
        ],
        setSelected: {
          parent: true,
        },
        searchfield: {
          placeholder: 'Поиск по разделам',
        },
      }, {}).data('mmenu');

      $body.on('click', '.js-nav-open', function () {
        let nav_active = $($(this).attr('data-nav-active'));

        if (nav_active) {
          nav_active.click();
          api.open();
        }
        return false;
      });

    }

    let setJivo = setInterval(function () {
      let jivo = $('#jivo-iframe-container');
      if (jivo.length) {
        clearInterval(setJivo);
      }
    }, 1000);

    $('.rslides').responsiveSlides({
      nav: true,
      prevText: ' ',
      nextText: ' ',
      timeout: 3000,
    });


    $hideSlide = $('.hide-slide');
    $hideSlide.on('mouseenter', function () {
      $(this).find('.hide-block').slideDown('fast');
    });
    $hideSlide.on('mouseleave', function () {
      $(this).find('.hide-block').slideUp('fast');
    });

    setTimeout(function () {
      $('.slider .bxSlider').each(function (index, element) {
        let $this = $(element);

        if ($this.find('.item').length > 1) $slider_adaptive[i++] = $this.bxSlider({
          controls: false,
          auto: true,
          touchEnabled: false,
          pause: 3000,
        });
      });

      $('.js-slider .bxSlider').each(function (index, element) {
        let $this = $(element);

        if ($this.find('.item').length > 1) $slider_adaptive[i++] = $this.bxSlider({
          pager: false,
          nextText: '',
          prevText: '',
          auto: true,
          touchEnabled: false,
          adaptiveHeight: true,
          pause: 3000,
        });
      });
    }, 300);

    $('.js-search').each(function (index, element) {
      let $this = $(element),
        $search = $this.find('[data-search-url]'),
        url = $search.data('search-url'),
        totrows = $($search.data('totrows'));
      $search.catcomplete({
        appendTo: $this,
        minLength: 3,
        select: function (request, response) {
          $.ajax({
            url: url,
            dataType: 'json',
            data: {
              search: request.term,
            },
            success: function (data) {
              if (totrows.length) totrows.text(data.totrows);
              response(data.results);
            },
          });
        },
        source: function (request, response) {
          $.ajax({
            url: url,
            dataType: 'json',
            data: {
              search: request.term,
            },
            success: function (data) {
              if (totrows.length) totrows.text(data.totrows);
              response(data.results);
            },
          });
        },
        search: function () {
          let data = $this.data('submit-success');
          let serialize = $this.serialize();
          actions(data, this, serialize);
        },
      });
    });

    $body.on('click', '.js-pager a', function () {
      let $this = $(this),
        data = $this.parents('.js-pager').removeData('array').data('array');

      actions(data, this);
      if ($(this).is('a')) return false;
    });

    let $search_snow = $('#search-snow');
    // События
    $window.on('resize load', function () {
      let window_width = $window.width();

      for (let $i = 0; $i < $slider_adaptive.length; $i++) {
        $slider_adaptive[$i].reloadSlider();
      }

      if ($search_snow.length) $search_snow.width(window_width).css({'margin-left': -(window_width / 2)});

      $('.js-slider-s .bxSlider').each(function (index, element) {
        let $this = $(element);

        // Слайдер адаптивный
        if (window_width <= 700 && $this.find('.item').length > 1 && $this.hasClass('active') === false) {
          let data = $this.data('bxslider');
          $slider_adaptive_items[index] = $this.addClass('active').bxSlider({
            controls: (!!data.controls),
            nextText: '',
            prevText: '',
            touchEnabled: false,
            pager: (!!data.pager),
            adaptiveHeight: true,
            pause: 3000,
          });
        }
        // Удаление слайдеров на титульной
        if (window_width > 700 && $this.hasClass('active') === true) {
          $slider_adaptive_items[index].removeClass('active').destroySlider();
          $('.js-slider-s .bxSlider, .js-slider-s .bxSlider .item').removeAttr('style');
        }
      });

      $('.js-slider-l .bxSlider').each(function (index, element) {
        let $this = $(element);

        // Слайдер адаптивный
        if ($this.find('.item').length > 1 && $this.hasClass('active') === false) {
          $slider_adaptive_l_items[index] = $this.addClass('active').bxSlider({
            controls: (!!$this.data('bxslider').controls),
            nextText: '',
            prevText: '',
            touchEnabled: false,
            pager: (!!$this.data('bxslider').pager),
            auto: true,
            adaptiveHeight: true,
            pause: 3000,
            onSliderLoad: function () {
              $('.js-slider-l .load').removeClass('load');
            },
          });
        }
      });

      $('.modal .window').each(function (index, element) {
        let $this = $(element);

        $this.css({
          'margin-top': '-' + $this.innerHeight() / 2 + 'px',
          'top': '50%',
        });
      });

    });

    $window.on('load scroll', '', function () {
      let scroll_top = $window.scrollTop();

      if (scroll_top > 0 && scroll_top < scroll_area) $socials.show();
      else $socials.hide();
    });

    // Выпадающие списки
    $body.on('click', '.select .drop, .select div, .select button', function () {
      $(this).parent().find('ul').slideToggle(100);
    });
    $body.on('click', '.select li', function () {
      let $this = $(this);

      $this.parent().slideToggle(100).parent().find('div').html($this.html());
      if ($this.parents('.select').data('selector')) $($this.parents('.select').data('selector')).val($this.data('value')).change();
    });
    $(document).click(function (event) {
      if ($(event.target).closest('.select').length)
        return;
      $('.select ul').slideUp(100);
      event.stopPropagation();
    });

    // Открыть галерею
    $body.on('click', '[data-lightbox]', function () {
      openPhotoSwipe($(this).data('lightbox').id);

      if ($(this).is('a')) return false;
    });

    // Клик
    $body.on('click', '[data-click]', function () {
      let data = $(this).removeData('click').data('click');

      actions(data, this);
      if ($(this).is('a')) return false;
    });
    // Изменение формы
    $body.on('change blur load', 'form[data-form-change] select, form[data-form-change] input, form[data-form-change]', function () {
      let data = $(this).parents('form').data('form-change');

      let serialize = $(this).parents('form').serialize();
      actions(data, this, serialize);
    });

    // Закладки групповые туры
    $('.js-tab ul').on('click', 'li', function () {
      console.log($(this));
      $(this).addClass('active').siblings().removeClass('active')
        .parents('.js-tab').parents('div').find('.js-tab-box').find('.block').removeClass('active').hide().eq($(this).index()).addClass('active').fadeIn(150);
      return false;
    });

    form_date();
    form_validate();
    mask();
    js_lazy();
    init_recapcha();

  });
})(jQuery);

// Функции
// Действия
function actions (data, $this, serialize) {

  for (let selector in data) {
    if (data.hasOwnProperty(selector)) {

      let $selector = $(selector);
      if (selector === 'this') $selector = $(element);


      if (data[selector].click === 'true') $selector.click();
      if (data[selector].focus === 'true') $selector.focus();
      if (data[selector].class) $selector.toggleClass(data[selector].class);
      if (data[selector].removeClass) $selector.removeClass(data[selector].removeClass);
      if (data[selector].addClass) $selector.addClass(data[selector].addClass);
      if (data[selector].text) $selector.text(data[selector].text);
      if (data[selector].val) $selector.val(data[selector].val);
      if (data[selector].remove) $selector.remove();
      if (data[selector].attr) $selector.attr(data[selector].attr);
      if (data[selector].removeAttr) $selector.removeAttr(data[selector].removeAttr);
      if (data[selector].alignTop) {
        setTimeout(function () {
          $selector.css({
            'margin-top': '-' + ($selector.innerHeight() - $(window).height()) / 2 + 'px',
            'top': '50%',
          });
        }, 200);
      }
      if (data[selector].toggle) {
        switch (data[selector].toggle) {
          case 'slide':
            $selector.slideToggle('fast');
            break;
          case 'slideUp':
            $selector.slideUp('fast');
            break;
          case 'slideDown':
            $selector.slideDown('fast');
            break;
          case 'fade':
            $selector.fadeToggle('fast');
            break;
          case 'fadeIn':
            $selector.fadeIn('fast');
            break;
          case 'fadeOut':
            $selector.fadeOut('fast');
            break;
        }
      }
      if (data[selector].scroll) {
        let offset = 0;

        if (data[selector].scroll !== 'true') offset = $selector.offset().top - parseInt(data[selector].scroll);
        else offset = $selector.offset().top;

        $('body, html').animate({scrollTop: offset});
      }
      if (data[selector].ajax) {
        let url = (data[selector].ajax.url ? data[selector].ajax.url : $($this).attr('href'));

        if (serialize) url = url + '?' + serialize;

        $.ajax({
          url: url,
          async: false,
          type: (data[selector].ajax.type ? data[selector].ajax.type : 'GET'),
          data: data[selector].ajax.data ? data[selector].ajax.data : {isNaked: 1},
          success: function (response) {
            let resp;

            if (data[selector].ajax.response) resp = $(response).find(data[selector].ajax.response);
            else resp = response;

            if (data[selector].ajax.selector === 'this') $selector.html(resp);
            else {
              if ($(data[selector].ajax.selector).length) $(data[selector].ajax.selector).html(resp);
            }

            form_validate();
            mask();
            form_date();
            $(window).resize();
            js_lazy();

            init_recapcha();
          },
        });
      }
    }
  }
}

// Полосы прокрутки
function frame (selector) { // .frame.:not(.active)
  $(selector).each(function (index, element) {
    let $frame = $(element),
      $wrap = $frame.parent(),
      $scrollbar = $wrap.find('.scrollbar'),
      $pages = $wrap.find('.pages'),
      $items = $frame.find('.item'),
      $prev = $wrap.find('.controls .prev'),
      $next = $wrap.find('.controls .next');

    $frame.addClass('active').sly({
      horizontal: false,
      itemNav: ($frame.data('array').itemNav ? 1 : null),
      smart: 1,
      activateMiddle: ($frame.data('array').itemNav ? 1 : null),
      activateOn: 'click',
      mouseDragging: 1,
      touchDragging: 1,
      releasSwing: 1,
      startAt: ($frame.data('array').itemNav === 'forceCentered' ? Math.round($items.length / 2) - 1 : 0),
      scrollBar: ($scrollbar.length ? $scrollbar : null),
      scrollBy: ($scrollbar.length ? 100 : null),
      speed: 300,
      elasticBounds: 1,
      easing: 'easeOutExpo',
      dragHandle: 1,
      dynamicHandle: 1,
      clickBar: 1,
      pagesBar: ($pages.length ? $pages : null),

      // Buttons
      prev: ($prev.length ? $prev : null),
      next: ($next.length ? $next : null),
    }).init();
  });
}

frame('.frame:not(.active)');

/*
function frame_size () {
  // Изменение размеров слайдов каталога
  $('.catalog .frame').each(function (index, element) {
    let $frame = $(element),
      $item = $frame.find('.item');

    if ($frame.data('array').full && $(window).width() <= 505) {
      $item.innerWidth($frame.width());
      frame('.catalog .frame');
    }else {
      $('.catalog .frame').sly(false);
      $item.removeAttr('style').removeClass('active');
    }
  });
}
*/

// Проверка форм
function form_validate () {
  $('form.validate:not(.active)').each(function (index, element) {
    let array = {warnText: null, response: null},
      $this = $(element),
      settings = [],
      data = $this.data('submit'),
      dataFail = $this.data('submit-fail'),
      dataSuccess = $this.data('submit-success');

    array = $this.data('array') || array;

    if ($this.data('settings')) settings = $this.data('settings');
    settings.invalidHandler = function () {
      $this.ajaxSubmit({
        data: {isNaked: 1},
        success: function (response, status, xhr, Form) {
          var
            warnText = $(response).filter('.warnText'),
            all = $(response);

          actions(data);

          if (warnText.length && warnText.length !== 'false') {
            if (array.warnText != null) $(array.warnText).html(warnText);
            else $(Form).find('.warnText').html(warnText);
          }else {
            if (array.warnText != null) $(array.warnText).html(all);
            else $(Form).find('.warnText').html(all);
          }

          actions(dataFail);
        },
      });
    };

    settings.submitHandler = function (form) {
      let $this_form = $(form),
        $submit = $this_form.find('[type=submit].submit');

      // Заблокировать кнопку
      if ($submit) {
        let $submit_text = $submit.find('.text');
        $submit.attr({'disabled': 'disabled', 'title': $submit.html()}).html('Отправка…');
        if ($submit_text) $submit_text.text('Отправка…');
        else $submit.text('Отправка…');
      }

      if (array.ajax !== 'false') {
        $(form).ajaxSubmit({
          data: {isNaked: 1},
          success: function (response) {
            var
              resp = ($(response).filter('.response').length ? $(response).filter('.response') : $(response).find('.response')),
              warnText = ($(response).filter('#nc_modal_status').length ? $(response).filter('#nc_modal_status') : $(response).find('#nc_modal_status')),
              all = $(response);

            actions(data);

            if (warnText.length) {
              if (warnText.length && warnText.length !== 'false') {
                if (array.warnText != null) $(array.warnText).html(warnText);
                else $this_form.find('.warnText').html(warnText);
              }else {
                if (array.warnText != null) $(array.warnText).html(all);
                else $this_form.find('.warnText').html(all);
              }
            }else {
              if (resp.length && resp.length !== 'false') {
                if (array.response) $(array.response).html(resp);
                else $this_form.closest('div').html(resp);
              }else {
                if (array.response) $(array.response).html(all);
                else $this_form.closest('div').html(all);
              }
            }

            // Разблокировать кнопку
            if ($submit) {
              let title = $submit.data('title') ? $submit.data('title') : $submit.attr('title');
              $submit.removeAttr('disabled').html(title);
              if ($submit_text) $submit_text.html(title);
              else $submit.html($submit.attr('title'));
            }

            actions(dataSuccess);
            mask();
            form_validate();

            form_date();
            js_lazy();
            init_recapcha();
          },
        });
      }
    };

    $this.addClass('active').validate(settings);
  });
}

// Маски
function mask () {
  $('[data-mask=phone]').mask('+7(999) 999-9999');
}

function form_date () {
  $('form').each(function (index, element) {
    let $this = $(element),
      $from = $this.find('.date-from'),
      $to = $this.find('.date-to'),
      $range = $this.find('.range');

    if ($from.length) {
      $from.datepicker({
        defaultDate: '+1w',
        changeMonth: true,
        numberOfMonths: 1,
        minDate: 0,
        dateFormat: 'd.m.yy',
        onClose: function (selectedDate) {
          if ($to.length) {
            $to.datepicker('option', 'minDate', selectedDate);
            $to.removeAttr('disabled').focus();
          }
        },
      });
    }
    if ($to.length) {
      $to.datepicker({
        defaultDate: '+1w',
        changeMonth: true,
        numberOfMonths: 1,
        minDate: 0,
        dateFormat: 'd.m.yy',
        onClose: function (selectedDate) {
          if ($from.length) {
            $from.datepicker('option', 'maxDate', selectedDate);
          }
        },
      });
    }

    if ($range.length) {
      $range.slider({
        range: true,
        min: 1,
        max: 25,
        appendText: '(yyyy-mm-dd)',
        currentText: 'Now',
        values: [parseInt($($range.data('selector')[0]).val()), parseInt($($range.data('selector')[1]).val())],
        slide: function (event, ui) {
          $($range.data('selector')[0]).val(ui.values[0]);
          $($range.data('selector')[1]).val(ui.values[1]);
          $($range.data('selector')[2]).html(ui.values[0] + ' &mdash; ' + ui.values[1]);
        },
        stop: function () {
          $($range.data('selector')[0]).blur();
        },
      });
    }
  });
}


function openPhotoSwipe (id) {
  let num = 0,
    items = [];
  let pswpElement = document.querySelectorAll('.pswp')[0];

  $('[data-lightbox]').each(function (index, element) {
    let $this = $(element);
    let item = {
      src: $this.attr('href'),
      w: parseInt($this.data('lightbox').w),
      h: parseInt($this.data('lightbox').h),
      title: $this.attr('title'),
    };
    if (id === $this.data('lightbox').id) num = index;
    items.push(item);
  });
  console.log(id, num);

  // define options (if needed)
  let options = {
    // history & focus options are disabled on CodePen
    history: false,
    focus: false,

    showAnimationDuration: 0,
    hideAnimationDuration: 0,
  };

  let gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
  gallery.goTo(num);
}

function js_lazy () {
  $('.js-lazy:not(.load)').addClass('load').Lazy();
}

function onloadCallback () {
  let mysitekey = '6LeGlhwTAAAAACcc2q7COinme9zcjJx9rfws9cEN';

  $('.recaptcha:not(.active)').each(function (index, element) {
    let $this = $(element);

    $this.addClass('active');

    grecaptcha.render($this.attr('id'), {
      'sitekey': mysitekey,
    });
  });
}

function init_recapcha () {
  setTimeout(function () { onloadCallback(); }, 1000);
}
